import { GetIDFromURL } from "99Tools/utils";
import { BrowserQRCodeReader, IScannerControls } from "@zxing/browser";
import Result from "@zxing/library/esm/core/Result";

export class Camera {
  public bShowCameraDlg = false;
  public camera = "";
  public cameras: MediaDeviceInfo[] = [];
  private bOn = false;
  private controls: IScannerControls | null = null;

  public async GetCameras() {
    try {
      // カメラの使用許可をユーザーに要求する
      await navigator.mediaDevices.getUserMedia({ video: true });

      this.cameras = [];
      this.cameras = (await BrowserQRCodeReader.listVideoInputDevices()).filter(
        (item: MediaDeviceInfo) => item.deviceId && item.deviceId !== ""
      );
    } catch (err) {
      console.error(
        "GetCameras処理内でカメラへのアクセスが拒否されました",
        err
      );
      this.cameras = [];
      this.camera = "";
      this.bOn = false;
      this.controls = null;
    }
  }

  public async CameraOn(
    id_name: string,
    setID: any,
    setMesasge: any,
    setIsReadFromCamera?: any
  ) {
    const videoElem = document.querySelector(`.${id_name}`) as HTMLVideoElement;
    if (this.bOn || this.camera === "" || !videoElem) {
      return;
    }
    const codeReader = new BrowserQRCodeReader();
    if (!codeReader) {
      return;
    }
    await codeReader
      .decodeFromVideoDevice(
        this.camera,
        videoElem,
        (
          result: Result | undefined,
          error: any,
          controls: IScannerControls
        ) => {
          // decode 完了時
          if (result) {
            controls.stop();
            this.controls = null;
            this.bOn = false;
            setID(GetIDFromURL(result.getText()));
            setIsReadFromCamera(true);
            setMesasge("");
          }
        }
      )
      .then((controls: IScannerControls) => {
        // decode 開始後
        this.controls = controls;
        this.bOn = true;
      })
      .catch((err: any) => {
        console.error(err);
      });
  }

  public async CameraOff() {
    if (!this.bOn || !this.controls) {
      return;
    }
    this.controls.stop();
    this.controls = null;
    this.bOn = false;
  }

  public async CameraSwitch(
    id_name: string,
    setID: any,
    setMessage: any,
    setIsReadFromCamera?: any
  ) {
    await this.CameraOff();
    await this.CameraOn(id_name, setID, setMessage, setIsReadFromCamera);
  }
}
